import { mobileMenu } from "./menu";
import headerInit from "./header";
import { getElement, ifSelectorExist, ready } from "./utils";
import { formEntry } from "./form_entry";
import { sliders } from "./sliders";
import { formDialogBottomNav, formDialogCtaSidebar, formDialogSingleAttorney, videoDialogWindow } from "./modals";
import { masonryGallery } from "./masonry-gallery";


// add email to hidden field in single attorney form
const addSingleAttorneyEmailToForm = () => {
  let singleAttorneyEmailSelector = getElement('.single_attorney_email');
  let fieldInModal = getElement('.form_recipient');
  if (ifSelectorExist(singleAttorneyEmailSelector) && ifSelectorExist(fieldInModal)) {
    fieldInModal.value = singleAttorneyEmailSelector.textContent;
  }
}

document.addEventListener('wpcf7mailsent', function (event) {
  // Function to handle form submission
  function handleFormSubmission(formId) {
    // Loop through the array to find a match
    for (var i = 0; i < cf7RedirectToArray.length; i++) {
      if (cf7RedirectToArray[i].select_form === formId) {
        // Redirect to the corresponding link
        window.location.href = cf7RedirectToArray[i].link_to_redirect_after_submit;
        break; // Exit the loop once a match is found
      }
    }
  }
  var formId = event.detail.contactFormId;
  handleFormSubmission(formId);
}, false);




ready(() => {
  mobileMenu();
  headerInit();
  formEntry();
  sliders();
  videoDialogWindow();
  formDialogBottomNav();
  formDialogSingleAttorney();
  addSingleAttorneyEmailToForm();
  masonryGallery();
  formDialogCtaSidebar();
});
